import React, {Component} from "react";
import BaseUrlConfig from '../../net/BaseUrlConfig';
import UrlConfig from '../../net/UrlConfig';

class GiftAttachmentRenderer extends Component {

  constructor(props) {
    super(props);

    this.invokeParentMethod = this.invokeParentMethod.bind(this);
    this.previewImgPath = BaseUrlConfig.api.REST_URL + BaseUrlConfig.api.API_VERSION + UrlConfig.DOWNLOAD_GIFT_HOSPITALITY_ATTACHMENT;
  }

  invokeParentMethod () {

  }

  render () {
    const node = this.props.node;

    let url;
    let attachmentOriginName;
    if (!!node) {
      const attachment = node.data.attachment;
      attachmentOriginName = node.data.attachmentOriginName;

      if (!!attachment) {
        url = this.previewImgPath + '/' + attachment;
      }
    }

    return (
      <div>
        {
          url && 
          <a href={url} target="_blank">{attachmentOriginName}</a>
        }
      </div>
    );
  }
}

export default GiftAttachmentRenderer;